/**
 * @flow
 * @author: Vamsi Tallam
 */

import React, { Component } from 'react'
import Slider from 'react-slick'
import LazyLoad from 'react-lazyload'
// NOTE: we are using react-lazy-load to fix the slick stacking of images issue

import {
  MediaContainer,
  LogoContainer,
  Logo,
  LogoLink,
  SlickInnerDiv,
  LogoContainerMobile
} from './styledComponents'

class NewsLogos extends Component {
  logoCollection = newsLogosList => {
    let slickArray = []
    let index
    let logosList
    let logosPerSlide = 6
    for (index = 0; index < newsLogosList.length; index += logosPerSlide) {
      logosList = newsLogosList.slice(index, index + logosPerSlide)
      slickArray.push(logosList)
    }
    return slickArray
  }

  renderLogo = (logo, isMobile = false) => {
    const { logoUrl, imageUrl, altText, mobileHeight, height } = logo
    const logoId = altText.split(' ').join('-')
    return (
      <LogoLink id={logoId} href={logoUrl} target="_blank">
        <Logo
          src={imageUrl}
          alt={altText}
          height={isMobile ? mobileHeight : height}
        />
      </LogoLink>
    )
  }

  render() {
    const { newsLogosList } = this.props
    let settings = {
      dots: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false
    }
    return (
      <MediaContainer>
        <LogoContainer>
          {newsLogosList.map(logo => this.renderLogo(logo))}
        </LogoContainer>
        <LazyLoad>
          <LogoContainerMobile>
            <Slider {...settings}>
              {this.logoCollection(newsLogosList).map(newsLogoList => (
                <div>
                  <SlickInnerDiv>
                    {newsLogoList.map(logo => this.renderLogo(logo, true))}
                  </SlickInnerDiv>
                </div>
              ))}
            </Slider>
          </LogoContainerMobile>
        </LazyLoad>
      </MediaContainer>
    )
  }
}

export default NewsLogos



// WEBPACK FOOTER //
// ./src/components/IbcNews/NewsLogos/index.js